import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { responsiveFontSizes, useTheme } from '@mui/material/styles';
import {
  Box, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableFooter,
  TablePagination, TableRow, TableHead, Paper, IconButton, Dialog, DialogActions,
  DialogContent, DialogContentText, DialogTitle, Button, Slide, Snackbar,
  Alert
} from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import {
  FirstPage as FirstPageIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage as LastPageIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { getMentorData, deleteMentorData, addMentor, editMentor, GetPrice } from "../services"; // 👈 adjust path if needed
import { useNavigate, useParams } from 'react-router-dom';
import AddPrice from '../component/addpricedialog';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import { safeDecryptId } from '../utils/safeDecryptId';

// Slide transition for dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Custom pagination actions
function TablePaginationActions({ count, page, rowsPerPage, onPageChange }) {
  const theme = useTheme();

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={(e) => onPageChange(e, 0)} disabled={page === 0}>
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={page === 0}>
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton onClick={(e) => onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function PriceList() {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [selectedMentorId, setSelectedMentorId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [formDialogOpen, setFormDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState(""); // or 'edit'
  const [selectedMentorPriceId, setSelectedMentorPriceId] = useState(null);
  const [mentorForm, setMentorForm] = useState({
    email: '',
    name: '',
    college: '',
    phone: '',
    rating: '',
    expertise: '',
    profile: null,
    about: '',
  });
  const [mentorId, setMentorId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMentorPrice, setSelectedMentorPrice] = useState(null);
  const { id: encryptedId } = useParams();
  const refreshMentorSlots = () => {
  if (selectedMentorPriceId) {
    fetchData(selectedMentorPriceId);
  }
  };
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const navigate = useNavigate();
  const handleAddMentor = () => {
    setMentorForm({
      email: '',
      name: '',
      college: '',
      phone: '',
      rating: '',
      expertise: '',
      profile: '',
      about: '',
    });
    setDialogMode('add');
    setFormDialogOpen(true);
  };

  const handleEditMentor = (mentor) => {
    setMentorForm(mentor);
    setDialogMode('edit');
    setFormDialogOpen(true);
  };
// console.log("fghjkl", mentorId);
  const fetchData = async () => {
    try {
      // console.log("fghjkl",mentorId)
      const res = await GetPrice(mentorId);
      // console.log("ress",res)
      setRows(res.data);
    } catch (err) {
      console.error('Error fetching mentors:', err);
    }
  };
  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  useEffect(() => {
    
     const decryptedId = safeDecryptId(encryptedId, secretKey);

        if (!decryptedId) {
            navigate("/unauthorized");
            return;
        }
        setMentorId(decryptedId);
        // fetchData();
  }, [encryptedId, secretKey]);
useEffect(() => {
  if (mentorId) {
    fetchData();
  }
}, [mentorId]);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
const Price = (priceData ) => {
  //  console.log("priceData.id",priceData?.mentor_id);
   
    
  if (priceData) {
    // EDIT
    setDialogMode('edit');
    setSelectedMentorPrice(priceData);
    setSelectedMentorPriceId(priceData.mentor_id);
  } else {
    // ADD
    setDialogMode('add');
    setSelectedMentorPrice(null);
    setSelectedMentorPriceId(mentorId); // use mentor id from URL
  }
  setOpenDialog(true);
};

  return (
    <>
<AddPrice
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  onSubmit={refreshMentorSlots}
  dialogMode={dialogMode} // 👈 pass add/edit mode
  selectedMentorPriceId={selectedMentorPriceId}
  selectedMentorPrice={selectedMentorPrice}
/>

      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: "15px" }}>
          <Button variant="contained" onClick={() => Price()}>Add Price</Button>
          <Typography variant='h4' gutterBottom></Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f0f0f0' }}>
                <TableCell>Mode</TableCell>
                <TableCell align="right">Duration</TableCell>
                <TableCell align="right">Price(INR)</TableCell>
                <TableCell align="right">Price(USD)</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : rows
              ).map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.label}</TableCell>
                  <TableCell align="right">{row.duration} Min</TableCell>
                  <TableCell align="right">{row.price}</TableCell>
                  <TableCell align="right">{row.price_in_usd}</TableCell>
                  <TableCell align="right">
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                      <IconButton color="secondary" size="small"  onClick={() => Price(row)}>
                        <EditIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </CardContent>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
